import React from 'react';
import Link from 'next/link';

const footerLinks = [
  { href: '/', label: 'Home' },
  { href: '/about', label: 'About' },
  { href: '/brands', label: 'Brands' },
  { href: '/gallery', label: 'Gallery' },
  { href: '/visit', label: 'Visit Us' },
  { href: '/contact', label: 'Contact' },
];

export default function Footer() {
  return (
    <footer className="bg-[#2B2B2B] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <div className="flex flex-col items-center md:items-start mb-4">
              <img
                src="/assets/images/Screenshot_2026-09-05_105509-Photoroom-1788602408777.png"
                alt="Amanda Jones Jewellery"
                className="h-14 md:h-16 w-auto object-contain"
              />
            </div>
            <p className="font-sans text-sm text-white/60 leading-relaxed mb-5">
              Contemporary silver jewellery boutique in the heart of Cowbridge, South Wales. Stockist of the finest designer silver brands.
            </p>
            <div className="flex items-center gap-4 justify-center md:justify-start">
              <a
                href="https://www.instagram.com/amanda13.jewellery/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-[#5FA828] transition-colors"
                aria-label="Instagram"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-[#5FA828] transition-colors"
                aria-label="Facebook"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Navigate + Contact: side by side on mobile */}
          <div className="grid grid-cols-2 gap-6 md:contents">
            {/* Navigate */}
            <div>
              <h4 className="font-sans text-[0.65rem] font-600 tracking-[0.2em] uppercase text-white/40 mb-4 md:mb-6">Navigate</h4>
              <div className="flex flex-col gap-2 md:gap-3">
                {footerLinks?.map((link) => (
                  <Link
                    key={link?.href}
                    href={link?.href}
                    className="font-sans text-sm text-white/70 hover:text-white transition-colors"
                  >
                    {link?.label}
                  </Link>
                ))}
              </div>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-sans text-[0.65rem] font-600 tracking-[0.2em] uppercase text-white/40 mb-4 md:mb-6">Visit &amp; Contact</h4>
              <div className="flex flex-col gap-2 md:gap-3">
                <div>
                  <p className="font-sans text-sm text-white/70">Cowbridge High Street</p>
                  <p className="font-sans text-sm text-white/70">Cowbridge, South Wales</p>
                </div>
                <div className="flex items-center w-full my-1">
                  <div className="flex-1 h-px bg-white/10" />
                  <div className="w-1 h-1 rounded-full bg-white/10 mx-2" />
                  <div className="flex-1 h-px bg-white/10" />
                </div>
                <div>
                  <p className="font-sans text-[0.65rem] tracking-[0.1em] uppercase text-white/40 mb-1">Opening Hours</p>
                  <p className="font-sans text-sm text-white/70">Mon–Sat: 9:30am – 5:00pm</p>
                  <p className="font-sans text-sm text-white/70">Sunday: Closed</p>
                </div>
                <div className="flex items-center w-full my-1">
                  <div className="flex-1 h-px bg-white/10" />
                  <div className="w-1 h-1 rounded-full bg-white/10 mx-2" />
                  <div className="flex-1 h-px bg-white/10" />
                </div>
                <a
                  href="https://www.instagram.com/amanda13.jewellery/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-sans text-sm text-[#5FA828] hover:text-[#7DC43A] transition-colors"
                >
                  @amanda13.jewellery
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 md:py-5 flex flex-col md:flex-row items-center justify-between gap-2 md:gap-3">
          <p className="font-sans text-xs text-white/40 text-center md:text-left">
            &copy; 2025 Amanda Jones Jewellery. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link href="/" className="font-sans text-xs text-white/40 hover:text-white/70 transition-colors">Privacy Policy</Link>
            <Link href="/" className="font-sans text-xs text-white/40 hover:text-white/70 transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
